import TextBox from './platform/core/component/TextBox/Component'
import Text from './platform/component/value/Text/Component'
import Image from './platform/component/media/Image/Component'
import Inherit from './platform/component/Inherit/Component'
import Div from './platform/component/Div/Component'

export default {
	'9988a56e-6bee-46c8-864c-e351d84bc7e2': TextBox,
	'87f99b85-1c24-4e5b-a903-dd27230f4092': Text,
	'059579bb-184f-435b-ace0-64ec95c9f125': Image,
	'b5286262-9f92-40d3-8545-88fb3079a0f9': Inherit,
	'66698a97-15c5-4602-9925-11a1aeb03710': Div,
}